import { render, staticRenderFns } from "./LohnInterface.vue?vue&type=template&id=6a430f51&scoped=true&"
import script from "./LohnInterface.vue?vue&type=script&lang=js&"
export * from "./LohnInterface.vue?vue&type=script&lang=js&"
import style0 from "./LohnInterface.vue?vue&type=style&index=0&id=6a430f51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a430f51",
  null
  
)

export default component.exports